define(["require", "exports", "hypo_elements/Typescripts/Configuration/Configuration", "jquery"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    jQuery(function ($) {
        function resizeContentBgImage(winWidth, objKey, value, key, alt, title) {
            if (alt === void 0) { alt = ''; }
            if (title === void 0) { title = ''; }
            if (winWidth <= Configuration_1.configuration.breakpointSmall && key == Configuration_1.configuration.breakpointSmall) {
                $('#hero' + objKey + ' .heroBackground img').attr('src', value)
                    .attr('alt', alt)
                    .attr('title', title)
                    .attr('width', 576);
            }
            if (winWidth > Configuration_1.configuration.breakpointSmall && winWidth <= Configuration_1.configuration.breakpointMedium && key == Configuration_1.configuration.breakpointMedium) {
                $('#hero' + objKey + ' .heroBackground img').attr('src', value)
                    .attr('alt', alt)
                    .attr('title', title)
                    .attr('width', 768);
            }
            if (winWidth > Configuration_1.configuration.breakpointMedium && winWidth <= Configuration_1.configuration.breakpointLarge && key == Configuration_1.configuration.breakpointLarge) {
                $('#hero' + objKey + ' .heroBackground img').attr('src', value)
                    .attr('alt', alt)
                    .attr('title', title)
                    .attr('width', 960);
            }
            if (winWidth > Configuration_1.configuration.breakpointLarge && winWidth <= Configuration_1.configuration.breakpointExtraLarge && key == Configuration_1.configuration.breakpointExtraLarge) {
                $('#hero' + objKey + ' .heroBackground img').attr('src', value)
                    .attr('alt', alt)
                    .attr('title', title)
                    .attr('width', 1200);
            }
            if (winWidth > Configuration_1.configuration.breakpointExtraLarge && key == 'orig') {
                $('#hero' + objKey + ' .heroBackground img').attr('src', value)
                    .attr('alt', alt)
                    .attr('title', title)
                    .attr('width', 1200);
            }
        }
        function contentBackgroundSize() {
            var winWidth = $(window).width();
            // @ts-ignore
            if (typeof TYPO3 !== 'undefined') {
                // @ts-ignore
                $.each(TYPO3.settings.CONTENTBG, function (objKey, objValue) {
                    var $obj = JSON.parse(objValue);
                    var alt = $obj['alt'];
                    var title = $obj['title'];
                    var newValue = '';
                    var haveBackground = 0;
                    var imgObj;
                    if ($obj['orig'].length) {
                        imgObj = $("#hero" + String(objKey) + " .heroBackground") || {};
                        haveBackground = imgObj.css('background-image').length || 0;
                        if (haveBackground) {
                            var valueNew = imgObj.css('background-image');
                            valueNew = valueNew.replace('url("', '').replace('")', '');
                            if (valueNew.length > 5) {
                                newValue = valueNew;
                            }
                        }
                    }
                    $.each($obj, function (key, value) {
                        if (newValue.length) {
                            value = newValue;
                        }
                        if (key !== 'alt' && key !== 'title') {
                            $(window).on('resize', function () {
                                var winWidth = $(window).width();
                                resizeContentBgImage(winWidth, objKey, value, key, alt, title);
                            });
                            resizeContentBgImage(winWidth, objKey, value, key, alt, title);
                        }
                    });
                    if (haveBackground) {
                        imgObj.removeAttr('style');
                    }
                });
            }
        }
        contentBackgroundSize();
        var heroCustomize = $('.heroCustomize');
        var headerBreadcrumb = $('.header_breadcrumb');
        var herobottom_wrap = $('.herobottom_wrap');
        function moveBreadcrumb() {
            if (heroCustomize.hasClass('withBreadcrumb')) {
                var heroHeight = heroCustomize.height();
                if (herobottom_wrap.length) {
                    heroHeight = heroCustomize.height() + (herobottom_wrap.height() / 2) - 18;
                }
                headerBreadcrumb.css('top', heroHeight + 'px');
            }
        }
        /**
         * Errechnet ein padding-bottom für ".herobottom". Der Info-Claimer ".herobottom_wrap" ist position absolute zu ".heroCustomize". Dies vermeidet das überlappen von Text und Info-Claimer.
         */
        function ajustInfoclaim() {
            if (heroCustomize.length) {
                heroCustomize.each(function () {
                    var heroContent = $(this).find('.heroContent');
                    var herobottomWrap = $(this).find('.herobottom_wrap');
                    var herobottom = $(this).find('.herobottom');
                    if (herobottomWrap.length) {
                        var heroContentHeight = heroContent.height() + 24;
                        var heroContentOffset = heroContent.offset() || null;
                        if (heroContentOffset !== null) {
                            heroContent.removeAttr('style');
                            var maxWidth = parseInt(heroContent.css('max-width').replace('%', ''));
                            if (maxWidth >= 66 || isNaN(maxWidth)) {
                                var heroContentTop = heroContentOffset.top;
                                var heroContentEnd = heroContentHeight + heroContentTop;
                                var herobottomWrapOffset = herobottomWrap.offset() || null;
                                var herobottomOffset = herobottom.position() || null;
                                if (herobottomWrapOffset !== null && herobottomOffset !== null) {
                                    var herobottomWrapTop = herobottomWrapOffset.top;
                                    var herobottomTop = herobottomWrapTop + herobottomOffset.top;
                                    var minPadding = 64;
                                    if (isNaN(maxWidth)) {
                                        minPadding = 44;
                                    }
                                    var needing = herobottomTop - minPadding;
                                    if (needing < heroContentEnd) {
                                        var padding = heroContentEnd - needing;
                                        heroContent.css('padding-bottom', padding + 'px');
                                    }
                                }
                            }
                        }
                    }
                });
            }
        }
        ajustInfoclaim();
        $(window).on("resize", function () {
            moveBreadcrumb();
            ajustInfoclaim();
        });
        moveBreadcrumb();
    });
});
